<template>
  <div>
    <nav-breadcrumb :menu="[{label: '发起用款申请'}]"/>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="listData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
      />
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "LoanApplyList",
      data(){
          return {
            page: 1,
            pageSize: 20,
            listData: {},
            filters: {
              labelWidth: '150px',
              form: {
                fi__transactionNo:'',
                fi__customerName:'',
                c__customerContactNo:'',
                fi__transactionDate:[],
              },
              columns: [
                {
                  label: '贷款编号',
                  component: 'el-input',
                  field: 'fi__transactionNo',

                },
                {
                  label: '客户姓名',
                  component: 'el-input',
                  field: 'fi__customerName',

                },
                /*{
                  label: '客户手机号',
                  component: 'el-input',
                  field: 'c__customerContactNo',

                },*/
                {
                  label: '申请日期',
                  component: 'date-range-picker',
                  field: 'fi__transactionDate',
                  op: ['gteq', 'lteq'],
                },

              ],
              onSubmit:()=>{
                this.page = 1
                this.getData()
              }
            }
          }
      },
      computed:{
        columns: function(){
          return [
            {
              type: 'index'
            },
            {
              label: '贷款编号',
              field: 'fi__transactionNo'
            },
            {
              label: '客户姓名',
              field: 'fi__customerName'
            },
           /* {
              label: '客户手机号',
              field: 'c__customerContactNo'
            },*/
            {
              label: '贷款金额',
              field: 'fi__totalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '合同利率(%)',
              field: 'fi__interestRate',
              formatter: function (r,c,v) {
                return v+'%'+'('+Status2CN(r.fi__interestType)+')'
              }
            },
            {
              label: '留存收益率(%)',
              field: 'dfi__interestRate',
              formatter: function (r,c,v) {
                return v+'%'+'('+Status2CN(r.dfi__interestType)+')'
              }
            },
            {
              label: '开始日期',
              field: 'fi__startDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              label: '结束日期',
              field: 'fi__endDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              label: '申请日期',
              field: 'fi__transactionDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              label: '状态',
              field: 'fi__transactionStatus',
              formatter: function (r,c,v) {
                return Status2CN('Financing_'+v)
              }
            },
            {
              label: '操作',
              opts:[
                {
                  label: '发起申请',
                  class: 'el-icon-success',
                  clickHandler: (index, row) => {
                     this.$router.push({
                       name: 'LoanApproveView',
                       query: {
                         'transactionId': row.fi__transactionId,

                       }
                     })

                  },
                  conditions: row=> {
                    return row.fi__transactionStatus=='Ready'

                  }
                },



              ]
            }
          ]
        },
        filterParams: {
          get: function() {
            return {
              pageSize: this.pageSize,
              pageOffset: (this.page - 1) * this.pageSize,
              'xlist.search.fi.transactionStatus' : 'Ready',
              'xlist.search.fi.transactionStatus.op' : 'in',
              'xlist.sort.dataField': 'fi.startDate',
              'xlist.sort.order': 'desc'
            }
          },
          set:function (newVal) {

          }
        }
      },
      watch: {
        filterParams: function () {
          this.getData()
        },
      },
      mounted(){
          this.getData()
      },
      methods:{
        getData: function () {
          xhr.getFinancingReadyForPayment(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res => {
              try {
                this.listData = res.data
              } catch (e) {

              }
            })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/LoanApplyList.vue